import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import hoistNonReactStatic from 'hoist-non-react-statics';

import { withConfig } from 'HOCs/withConfig/withConfig';
import { getFooterLinks } from 'Actions/seoFooter';
import withRouter from 'HOCs/withRouter';

const withFooterLinks = (mapPropsToQuery = () => ({})) => WrappedComponent => {
    const configWrapper = c => ({
        get: (...args) => args.reduce((v = {}, k) => v[k], c)
    });

    class WithFooterLinks extends React.Component {
        componentDidMount() {
            const query = mapPropsToQuery(this.props) || {};

            this.props.getFooterLinks(query);
        }

        componentDidUpdate() {
            const query = mapPropsToQuery(this.props) || {};

            this.props.getFooterLinks(query);
        }

        render() {
            const {
                __config, // eslint-disable-line no-unused-vars
                getFooterLinks, // eslint-disable-line no-unused-vars
                ...props
            } = this.props;

            return (
                <WrappedComponent
                    { ...props }
                    data-aut-id="withFooterLinksComponent"
                />
            );
        }
    }

    WithFooterLinks.propTypes = {
        getFooterLinks: PropTypes.func.isRequired,
        __config: PropTypes.shape({
            get: PropTypes.func.isRequired
        }).isRequired
    };

    WithFooterLinks.fetchData = (...args) => {
        const [dispatch, renderProps, reqProps, reqContext, store] = args; // eslint-disable-line no-unused-vars
        const query = mapPropsToQuery({ ...renderProps, ...reqProps });

        return Promise.all([
            (WrappedComponent.fetchData ? WrappedComponent.fetchData(...args) : Promise.resolve()),
            getFooterLinks(configWrapper(reqContext.config), query, reqProps)(dispatch, store.getState)
        ]);
    };

    const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';

    WithFooterLinks.displayName = `withFooterLinks(${wrappedComponentName})`;

    const mapDispatchToProps = (dispatch, props) => ({
        getFooterLinks: params =>
            dispatch(getFooterLinks(props.__config, params, undefined, true))
    });

    return hoistNonReactStatic(
        compose(
            withRouter,
            withConfig('__config'),
            connect(undefined, mapDispatchToProps)
        )(WithFooterLinks),
        WrappedComponent,
        { fetchData: true }
    );
};

export default withFooterLinks;
